<template>

  <div id="app">
    <router-view ></router-view>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        
      }
    },
    computed: {
      
    },
    watch: {
      
    },
    created() {
      
    },
    mounted() {
      
    },
    methods: {
    }
  }

</script>

<style>
  #app {
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// App.vue?2c9892b6